// A11Y-10: polite SR announcements. LiveRegion is mounted once in PrivateLayout;
// call announce() from anywhere to push a message.
let listener = null;
let pending = null;
let lastMessage = "";
let lastTimestamp = 0;

const DEDUPE_WINDOW_MS = 1000;

export function subscribe(fn) {
    listener = fn;
    if (pending !== null) {
        const msg = pending;
        pending = null;
        listener(msg);
    }
    return () => {
        if (listener === fn) listener = null;
    };
}

export function announce(message) {
    if (typeof message !== "string" || message.trim() === "") return;
    const now = Date.now();
    // Skip identical back-to-back messages to avoid spam.
    if (message === lastMessage && now - lastTimestamp < DEDUPE_WINDOW_MS) return;
    lastMessage = message;
    lastTimestamp = now;
    if (listener) {
        listener(message);
    } else {
        pending = message;
    }
}
